// 拉取微信授权

import { appId, WxEndUrl, WxHeaderUrl } from '@/utils/routeList'

export function WXlogin(path = '') {
  const appid = appId
  const back_end_url = process.env.VUE_APP_WXAUTH_CALLBACK // 回调后端地址
  // 拼接授权路径
  const final_url = WxHeaderUrl + appid + '&redirect_uri=' +
    back_end_url +
    '?' +
    encodeURIComponent('redirectUrl=') + encodeURIComponent(`${window.location.origin}`) +
    '%2fbackPage' + WxEndUrl
  window.location.href = final_url
  sessionStorage.setItem('userStats', false) // 存入用户状态
}

export function testWxOpenid(path = '') {
  const appid = appId
  const back_end_url = process.env.VUE_APP_OPENID_CALLBACK // 回调后端地址
  // 拼接授权路径
  const final_url = WxHeaderUrl + appid + '&redirect_uri=' +
    back_end_url +
    '?' +
    encodeURIComponent('redirectUrl=') + encodeURIComponent(`${window.location.origin}`) +
    '%2fopenIdPage' + WxEndUrl
  window.location.href = final_url
}

